import React, { Component } from 'react'
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap'
import { NavLink as RRNavLink } from 'react-router-dom'
import BrandIMG from '../../assets/images/navbar-brand.png'

const SocialMediaLink = () => {
  return (
    <div className="d-flex flex-row">
      <NavItem className="pr-2">
        <NavLink tag={RRNavLink} to="/#">
          <i className="fab fa-tripadvisor" />
        </NavLink>
      </NavItem>
      <NavItem className="pr-2">
        <NavLink tag={RRNavLink} to="/#">
          <i className="fab fa-instagram" />
        </NavLink>
      </NavItem>
      <NavItem className="pr-2">
        <NavLink tag={RRNavLink} to="/#">
          <i className="fab fa-facebook" />
        </NavLink>
      </NavItem>
      <NavItem className="pr-2">
        <NavLink tag={RRNavLink} to="/#">
          <i className="fab fa-twitter" />
        </NavLink>
      </NavItem>
    </div>
  )
}
class Header extends Component {
  state = {
    isOpen: false,
  }

  toggle = () => {
    this.setState({
      isOpen: !this.state.isOpen,
    })
  }

  render() {
    return (
      <div className="main-header">
        <Navbar color="light" light expand="md">
          <NavbarBrand tag={RRNavLink} to="/">
            <img className="brand" src={BrandIMG} alt="Morning Bali Tour" />
          </NavbarBrand>
          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <SocialMediaLink />
              <NavItem>
                <NavLink
                  onClick={() => (this.state.isOpen ? this.toggle() : {})}
                  to="/book"
                  tag={RRNavLink}>
                  Booking Info
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  onClick={() => (this.state.isOpen ? this.toggle() : {})}
                  to="/about"
                  tag={RRNavLink}>
                  About
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  onClick={() => (this.state.isOpen ? this.toggle() : {})}
                  to="/gallery"
                  tag={RRNavLink}>
                  Gallery
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Navbar>
      </div>
    )
  }
}

export default Header
